export const CHANGE_PRIMARY_COLOR = 'CHANGE_PRIMARY_COLOR';